<template>
  <textarea
    :placeholder="placeholder"
    @input="updateValue"
    :value="$attrs.value"
  >
  </textarea>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      required: false,
    },
  },
  methods: {
    updateValue(e) {
      this.$emit("input", e.target.value);
    }
  }
}
</script>